import { Helmet } from "react-helmet-async";

interface GoogleAnalyticsProps {
  measurementId?: string;
}

export const GoogleAnalytics: React.FC<GoogleAnalyticsProps> = ({
  measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID,
}) => {
  if (!measurementId) {
    console.warn("Google Analytics measurement ID not provided");
    return null;
  }

  return (
    <Helmet>
      <script async src={`https://www.googletagmanager.com/gtag/js?id=${measurementId}`}></script>
      <script>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag() {
            window.dataLayer.push(arguments);
          }
          gtag("js", new Date());
          gtag("config", "${measurementId}", { custom_map: {
              userType: "userType",
            },
          });
          window.gtagReady = true;
          console.log("Google Analytics initialized");
        `}
      </script>
    </Helmet>
  );
};
